import React, { Component } from 'react'
import http from "./http-common";
import Axios, { AxiosRequestConfig } from 'axios';
import API from "../helpers/api";
class appService {
    getMaterialDetail(type,table,threshold,material) {
        let url=`${API.MasterMaterialInformation}?tabletype=${type}&tablevalue=${table}&thresholdvalue=${threshold}&materialname=${material}`
        return http.get(url);
      }
}

export default new appService();
